import { createFileRoute } from "@tanstack/react-router";
import FooterSettings from "@/pages/admin/FooterSettings";

export const Route = createFileRoute("/admin/footer-settings")({
  component: FooterSettings,
});
